import { useEffect, useState, useRef } from "react";
import { useForceUpdate } from "../../services/shared";
import Button from "../Button/Button";
import Checkbox from "../Checkbox/Checkbox";
import backIcon from '../../assets/images/icons/left-arrow.svg';
import chevroletCar from '../../assets/images/chevrolet-car.jpg'
import gmcCar from '../../assets/images/gmc-car.jpg'
import kiaCar from '../../assets/images/kia-car.jpg'
import volkswagenCar from '../../assets/images/volkswagen-car.jpg'
import chevroletCarOnly from '../../assets/images/chevrolet-car-icon.png'
import gmcCarOnly from '../../assets/images/gmc-car-icon.png'
import kiaCarOnly from '../../assets/images/kia-car-icon.png'
import volkswagenCarOnly from '../../assets/images/volkswogen-car-icon.png'
import chevroletCarMob from '../../assets/images/chevrolet-mob.png'
import gmcCarMob from '../../assets/images/gmc-mob.svg'
import kiaCarMob from '../../assets/images/kia-mob.png'
import volkswagenCarMob from '../../assets/images/volkswogen-mob.png'
import makeLogoMob from '../../assets/images/cars/make-logos/make-logo.svg'
import { brandLogos } from "../../constants";

import './ListingFilters.scss';

const ListingFilters = ({filterChanged, closeFilters, filters=[], toggleResults})=>{
    
    const forceUpdate = useForceUpdate()
    const [selectedOptionIndex, setSelectedOptionIndex] = useState(null);
    const selectedLiRef = useRef(null);

    const [mobileOpenFilter, setMobileOpenFilter] = useState('Price')
    const makeList = ['Kia', 'GMC', 'Chevrolet', 'Volkswagen'];

    const url = new URL(window.location);
    const params = url.searchParams;

    const [isDesktop, setIsDesktop] = useState(window.innerWidth > 700);


    useEffect(() => {
        const handleResize = () => {
            setIsDesktop(window.innerWidth > 700);

        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(()=>{
        // Price filter from URL
        const params = new URLSearchParams(window.location.search);
        const minFromURl = parseFloat(params.get('minPrice'));
        const maxFromURl = parseFloat(params.get('maxPrice'));
        if(!isNaN(minFromURl)  && !isNaN(maxFromURl) ){
            const priceFilter = filters.find(_=>_.property === 'price');
            priceFilter.options.forEach(option=>{
                option.active = option.min >= minFromURl && option.max <= maxFromURl
            })
        }
        
    },[])

    useEffect(() => {
        if(filters.length > 0){
            const activeIndex = filters[2].options.findIndex(option => option.active)
            setSelectedOptionIndex(activeIndex);
        }else if(params.get('makeFilters')){
            const activeIndex = filters[2].options.findIndex(option => option.name === params.get('makeFilters'))
            setSelectedOptionIndex(activeIndex);
        }
      }, [filters, params]);

      useEffect(()=>{
        if (selectedLiRef.current) {
            selectedLiRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }
      },[selectedOptionIndex])

    function clearAll(){
        filters.forEach(filter=>{
            filter.options.forEach(option=>{
                option.active = false;
            })
        })
        applyFilter();
    }

    function applyFilter(){
        forceUpdate();
        filterChanged();
    }

    function hasAnyOptionsActive(filter){
        return filter.options.findIndex(_=>_.active) > -1
    }

    function activeOptionCount(filter){
        const activeOptions = filter.options.filter(_=>_.active);
        return activeOptions.length
    }
    return (
        <div className="listing-filters">
            <div className="listing-filters--header">
                <span className="listing-filters--header--back" onClick={()=>{
                    window.dataLayer?.push({
                        'event': 'Open/Close mobile filters',
                        'event_category': 'Filters',
                        'event_label': 'Back icon',
                        'event_action': 'Close'
                    })
                    closeFilters();
                }}>
                    <img src={backIcon}/>
                </span>
                <span>Filters</span>
                <span className="listing-filters--header--clear" onClick={()=>{
                    window.dataLayer?.push({
                        'event': 'Changed filters',
                        'event_category': 'Filters',
                        'event_label': 'All',
                        'event_action': 'Clear'
                    })
                    clearAll();
                }}>Clear All</span>
            </div>
            <ul className="listing-filters--list">
                {
                    filters.map((filter,i)=>(
                        (( window.location.pathname==='/listing' && filter.name!=='Condition') || (window.location.pathname==='/marketplace')) && <li key={i} className={`listing-filters--list--item ${mobileOpenFilter === filter.name?'mobile-open':''} ${!filter.close?'open':''}`}>
                            <div className="listing-filters--list--item--header" onClick={()=>{
                                filter.close = !filter.close;
                                setMobileOpenFilter(filter.name);
                                forceUpdate();
                            }}>
                                {filter.name}
                                &nbsp;{activeOptionCount(filter)?`(${activeOptionCount(filter)})`:''}
                            </div>
                            <ul  style={isDesktop? {maxHeight:"200px",overflowY:"scroll",paddingRight:"30px"}:{height:"auto"}} className={window.location.pathname==="/marketplace" && 'listing-filters-scrollbar'}>
                                {
                                  window.location.pathname==="/listing" &&  (params.get('tmpl') === 't1' || params.get('tmpl') === 't2') ? filter.options.map((option,j)=>(
                                        makeList.includes(option.name) && (<li key={j} className={` ${option.active?'checked':''}`} onClick={()=>{
                                            toggleResults();
                                            filter.options.map((option, j) => {
                                                option.active = false;
                                                return option;
                                            });
                                            option.active = !option.active;
                                            window.dataLayer?.push({
                                                'event': 'Changed filters',
                                                'event_category': 'Filters',
                                                'event_label': filter.name,
                                                'event_value': option.name,
                                                'event_action': option.active?'CHECKED':'UNCHECKED'
                                            })
                                            applyFilter();
                                        }}>
                                            <div className="make-img-list">
                                                <div className="img-wrap">
                                                    <img src={option.name === "Chevrolet" ? chevroletCar : option.name === "GMC" ? gmcCar : option.name === "Kia" ? kiaCar : volkswagenCar} alt="" />
                                                    <img className="img-car-only" src={option.name === "Chevrolet" ? chevroletCarOnly : option.name === "GMC" ? gmcCarOnly : option.name === "Kia" ? kiaCarOnly : volkswagenCarOnly} alt="" />
                                                </div>
                                                <div className="img-wrap-mob d-none">
                                                    <img src={option.name === "Chevrolet" ? chevroletCarMob : option.name === "GMC" ? gmcCarMob : option.name === "Kia" ? kiaCarMob : volkswagenCarMob} alt="" />
                                                    <div className="text">{option.name}</div>
                                                </div>
                                                <div className="cta-wrap flex justify-center items-center">
                                                    <div className="text">Explore Now</div>
                                                    <div class="arrow-anim-wrapper">
                                                        <div class="arrow delay1"></div>
                                                        <div class="arrow delay2"></div>
                                                        <div class="arrow delay3"></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="cta">{option.name}</div>
                                        </li>)
                                    )) : filter.options.map((option,j)=>(
                                        <li key={j} className={`flex items-center ${option.active?'checked':''}`} onClick={()=>{
                                            option.active = !option.active;
                                            window.dataLayer?.push({
                                                'event': 'Changed filters',
                                                'event_category': 'Filters',
                                                'event_label': filter.name,
                                                'event_value': option.name,
                                                'event_action': option.active?'CHECKED':'UNCHECKED'
                                            })
                                            applyFilter();
                                        }}>
                                            <span className="flex-auto">{option.name}</span>
                                            <Checkbox className="justify-self-end"></Checkbox>
                                        </li>
                                    ))
                                }
                                {
                                    window.location.pathname==="/listing" &&  params.get('tmpl') === 't2' && <li className="remaining-listings-heading">
                                        <h2 className="heading" style={{display: "none"}}>Explore Our Range of Available Brands</h2>
                                    </li>
                                }
                                {
                                    window.location.pathname==="/listing" &&  params.get('tmpl') === 't2' ? filter.options.map((option,j)=>(
                                        !makeList.includes(option.name) && (<li key={j} ref={j === selectedOptionIndex ? selectedLiRef : null} className={` ${option.active?'checked':''}`} onClick={()=>{
                                            toggleResults();
                                            setSelectedOptionIndex(j);
                                            filter.options.map((option, j) => {
                                                option.active = false;
                                                return option;
                                            });
                                            option.active = !option.active;
                                            window.dataLayer?.push({
                                                'event': 'Changed filters',
                                                'event_category': 'Filters',
                                                'event_label': filter.name,
                                                'event_value': option.name,
                                                'event_action': option.active?'CHECKED':'UNCHECKED'
                                            })
                                            applyFilter();
                                        }}>
                                            <div className="make-img-list">
                                                <div className="img-wrap">
                                                    <img src={option.name === "Chevrolet" ? chevroletCar : option.name === "GMC" ? gmcCar : option.name === "Kia" ? kiaCar : volkswagenCar} alt="" />
                                                    <img className="img-car-only" src={option.name === "Chevrolet" ? chevroletCarOnly : option.name === "GMC" ? gmcCarOnly : option.name === "Kia" ? kiaCarOnly : volkswagenCarOnly} alt="" />
                                                </div>
                                                <div className="img-wrap-mob d-none">
                                                    <img src={brandLogos.find(brand => brand.name === option.name)?.logo ? brandLogos.find(brand => brand.name === option.name)?.logo : makeLogoMob} alt="" />
                                                    <div className="text">{option.name}</div>
                                                </div>
                                                <div className="cta-wrap flex justify-center items-center">
                                                    <div className="text">Explore Now</div>
                                                    <div class="arrow-anim-wrapper">
                                                        <div class="arrow delay1"></div>
                                                        <div class="arrow delay2"></div>
                                                        <div class="arrow delay3"></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="cta">{option.name}</div>
                                        </li>)
                                    )) : ''
                                }
                            </ul>
                            <div className={`clear-button ${!hasAnyOptionsActive(filter)?'disabled':''}`} onClick={()=>{
                                window.dataLayer?.push({
                                    'event': 'Changed filters',
                                    'event_category': 'Filters',
                                    'event_label': filter.name,
                                    'event_action': 'Clear'
                                })
                                filter.options.forEach(_=>_.active = false);
                                applyFilter();
                            }}>Clear All</div>
                        </li>
                    ))
                }
            </ul>
            <div className="listing-filters--apply">
                <Button className="l primary" onClick={()=>{
                    closeFilters();
                }}>Show Results</Button>
            </div>
        </div>
    )
}

export default ListingFilters;